import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import icons from '@/icons'
import $http from './utils/request.js'
import ElementUI from "element-ui";
import cookies from 'vue-cookies'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.prototype.$http = $http
cookies.config('1d')
Vue.prototype.$cookies = cookies;
Vue.config.productionTip = false

new Vue({
  router,
  store,
  $http,
  render: h => h(App)
}).$mount('#app')
